// deploy-pipelines-run-cancel (Wave 5, AC-21/TC-DPRC-017) — maps the cancel endpoint's error
// responses to a user-facing message, mirroring mapRunTriggerError's precedent (its own jest
// suite pins the mapping directly, not only through the component it's used from).
//
// A 409 is the EXPECTED, most-likely-in-practice outcome here — not an edge case: the run
// moved on between the last poll (~4s cadence) and the user's click. It gets its own
// non-alarming message rather than falling through to the generic sentence, and the caller
// (PipelineRunAction) is expected to also refresh the displayed run when this fires.
export const mapCancelRunError = (error) => {
  const status = error?.response?.status;
  const serverMessage = error?.response?.data?.message;

  if (status === 409) {
    return serverMessage || 'This run has already moved on and can no longer be cancelled.';
  }
  if (status === 404) {
    return 'This run no longer exists.';
  }
  if (status === 401 || status === 403) {
    return 'You do not have permission to cancel this run.';
  }
  return error?.message || 'Something went wrong cancelling this run.';
};

export default mapCancelRunError;
